/**
 * Replaces src/environments/*.ts and the angular.json fileReplacements swap.
 * Values come from .env.development / .env.stg / .env.production, selected by
 * Vite's --mode flag at build time.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing environment variable ${name}. Check the .env file for this build mode.`,
    );
  }
  return value;
}

export const env = {
  production: import.meta.env.PROD,
  userPoolId: required('VITE_USER_POOL_ID', import.meta.env.VITE_USER_POOL_ID),
  userPoolClientId: required('VITE_USER_POOL_CLIENT_ID', import.meta.env.VITE_USER_POOL_CLIENT_ID),
  identityPoolId: required('VITE_IDENTITY_POOL_ID', import.meta.env.VITE_IDENTITY_POOL_ID),
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL),
} as const;
